export default "__VITE_ASSET__BbU0ILMc__"